export default class TeacherInfoService {
  constructor(http) {
    this.http = http;
  }

  async findAllTeacherInfoWithRegiInfoBySchoolid(teacherInfo = {}) {
    const queryParams = Object.entries(teacherInfo)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/teacherinfo/readallWithUsers?${queryParams}`, {
      method: "GET",
    });
  }

  // async findTeacherInfo(teacherInfo) {
  //   console.log("service", teacherInfo);
  //   return this.http.fetch(`/api/teacherinfo/read-one-user`, {
  //     method: "GET",
  //     body: JSON.stringify(teacherInfo),
  //   });
  // }

  async findTeacherInfo(teacherInfo) {
    const queryParams = Object.entries(teacherInfo)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/teacherinfo/read-one-user?${queryParams}`, {
      method: "GET",
    });
  }

  async updateTeacherInfo(teacherInfo) {
    return this.http.fetch(`/api/teacherinfo/update`, {
      method: "PUT",
      body: JSON.stringify(teacherInfo),
    });
  }

  async createTeacherInfo(teacherInfo) {
    return this.http.fetch(`/api/teacherinfo/create`, {
      method: "POST",
      body: JSON.stringify(teacherInfo),
    });
  }

  async bulkTeacherInfo(bulkData) {
    return this.http.fetch(`/api/teacherinfo/bulk-upload`, {
      method: "POST",
      body: JSON.stringify(bulkData),
    });
  }
}
